import {
  mdiAccountCog,
  mdiAccountSearch,
  mdiAccountSearchOutline,
  mdiAttachment,
  mdiCalendarToday,
  mdiChatOutline,
  mdiChatQuestion,
  mdiChatQuestionOutline,
  mdiPoll,
  mdiCog,
  mdiCogOutline,
  mdiCurrencyEur,
  mdiCurrencyEurOff,
  mdiFormatQuoteClose,
  mdiGroup,
  mdiHomeGroup,
  mdiHomeOutline,
  mdiInformationOutline,
  mdiLogout,
  mdiMenu,
  mdiNewspaper,
  mdiSend,
  mdiSendOutline
} from '@mdi/js'


export default [
  {
    title: 'Etusivu',
    icon: mdiHomeOutline,
    to: 'home',
  },
  {
    title: 'Meidän yritys',
    dynamicTitle: true,
    dynamicTitleKey: 'our_company',
    icon: mdiInformationOutline,
    to: 'company-pages',
  },
  {
    title: 'Uutiset',
    dynamicTitle: true,
    dynamicTitleKey: 'news',
    icon: mdiFormatQuoteClose,
    to: 'news-list',
  },
  {
    title: 'Tapahtumat',
    icon: mdiCalendarToday,
    to: 'events',
  },
  {
    title: 'Tiedostot',
    icon: mdiAttachment,
    to: 'resources',
    optional: true,
    optional_key: 'resources_enabled',
  },
  {
    title: 'Keskustelut',
    optional: true,
    optional_key: 'chat_enabled',
    disabled_read_only: true,
    key: 'chat',
    icon: mdiChatOutline,
    to: 'chat',
  },
  {
    title: 'Muut',
    icon: mdiMenu,
    children: [
      {
        title: 'Jätä palaute tai kysymys',
        icon: mdiSendOutline,
        to: 'feedback',
      },
      {
        title: 'Meillä töissä',
        dynamicTitle: true,
        dynamicTitleKey: 'people',
        optional: true,
        optional_key: 'people_enabled',
        icon: mdiAccountSearchOutline,
        to: 'people',
      },
      {
        title: 'Henkilöstöedut',
        optional: true,
        optional_key: 'benefits_enabled',
        key: 'benefits',
        icon: mdiCurrencyEur,
        to: 'benefits',
      },
      {
        title: 'Kysymykset & vastaukset',
        icon: mdiChatQuestionOutline,
        to: 'faq',
      },
      {
        title: 'Kyselyt',
        icon: mdiPoll,
        disabled_read_only: true,
        to: 'polls-list',
      },
      {
        title: 'Omat tiedot & asetukset',
        disabled_read_only: true,
        icon: mdiAccountCog,
        to: 'profile',
      },
      {
        title: 'Piiri-artikkelit',
        optional: true,
        optional_key: 'piiri_articles_enabled',
        icon: mdiNewspaper,
        to: 'piiri-articles',
      },
      {
        title: 'Hallinta',
        icon: mdiCogOutline,
        disabled_read_only: true,
        to: 'admin-home',
        admin: true
      },
      {
        title: 'Kirjaudu ulos',
        icon: mdiLogout,
        to: 'auth-logout',
      }
    ]
  },
]
